import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { lazyPage, reloadOnPreloadError, ScreenErrorBoundary } from "./errors";
import { isSpiritListRoute } from "./features/products/spiritListRoute";
import "./styles/tokens.css";
import "./styles.css";

// The printable spirit list is a separate route; load it (and the product-view
// and unit-formatting code it needs) only when that route is opened.
const SpiritListPage = lazyPage(() =>
  import("./features/products/SpiritList").then((m) => ({
    default: m.SpiritListPage,
  })),
);
// The public help center (/help): the feature docs as help pages, no sign-in (docs/features/help.md).
const HelpCenter = lazyPage(() =>
  import("./features/help/HelpCenter").then((m) => ({ default: m.HelpCenter })),
);
const isHelpRoute = () => location.pathname === "/help" || location.pathname.startsWith("/help/");
// After a redeploy an open tab asks for page files that no longer exist: reload once.
reloadOnPreloadError();
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* Last line of defence: a failure outside any screen shows a panel, never a blank page. */}
    <ScreenErrorBoundary page="app">
      {isHelpRoute() ? (
        <Suspense fallback={null}>
          <HelpCenter />
        </Suspense>
      ) : isSpiritListRoute() ? (
        <Suspense fallback={null}>
          <SpiritListPage />
        </Suspense>
      ) : (
        <App />
      )}
    </ScreenErrorBoundary>
  </React.StrictMode>,
);
